export const studioVoicePreviewQueryKey = (fileId) => [
	'studio-voice-preview',
	fileId,
];
